import {
    UPDATE_REPORT_SELECTION,
    DOWNLOAD_REQUESTED,
    DOWNLOAD_COMPLETED,
    RESET_REPORT_SELECTION
} from './download-report-actions';

const initialState = {
    reportTypes: [],
    isProcessingDownload: false
};

export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case UPDATE_REPORT_SELECTION: {
            return {
                ...state,
                reportTypes: getUpdatedReportType(
                    state.reportTypes,
                    action.reportTypes
                )
            };
        }

        case DOWNLOAD_REQUESTED:
            return {
                ...state,
                isProcessingDownload: true
            };

        case DOWNLOAD_COMPLETED:
            return {
                ...state,
                isProcessingDownload: false
            };

        case RESET_REPORT_SELECTION:
            return {
                ...state,
                reportTypes: []
            };
        default:
            return state;
    }
}

/**
 * Multiple report formats can be selected. If exists we remove... if not we append
 * @param currentReportType: state.reportTypes
 * @param payload: action.payload
 * @returns updated report formats array
 */
function getUpdatedReportType(currentReportType, payload) {
    const updatedReportFormat = [...currentReportType];

    if (currentReportType.includes(payload)) {
        return updatedReportFormat.filter((item) => item !== payload);
    }

    return [...updatedReportFormat, payload];
}



// WEBPACK FOOTER //
// ./components/sub-heading/download-report/download-report-reducer.js